import { z } from 'zod'
import type { VenueTagVenueCollection } from '~/client/common/typesense/collections'

const VenueTagVenueDocumentFromTypesense = z.object({
  id: z.string(),
  biblio_venue_id: z.number().nullable().optional(),
  name: z.string(),
  display_address: z.string().nullable().optional(),
  venue_group: z
    .object({
      id: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
}) satisfies z.ZodType<VenueTagVenueCollection, VenueTagVenueCollection>

export const VenueTagVenueFromTypesense = VenueTagVenueDocumentFromTypesense.transform((doc) => ({
  id: doc.biblio_venue_id ?? Number(doc.id),
  name: doc.name,
  address: doc.display_address ?? '',
}))

export const VenueTagVenueSearchResponseFromTypesense = z.object({
  hits: z
    .array(
      z.object({
        document: VenueTagVenueFromTypesense,
      }),
    )
    .optional(),
})
